<template>
    <b-container fluid class="vh-100">
        <b-row class="align-items-start justify-content-end h-100">
            <b-col cols="12" lg="auto" class="mt-3">
                <DropdownLanguage/>
            </b-col>
            <b-col cols="12" lg="12" class="text-center">
                <div v-if="!is_requesting_access && !is_request_done && !fail_message" class="p-4">
                    <BIconQuestionCircleFill class="mb-3" variant="warning" style="width: 4rem; height: 4rem;"/>
                    <h4 class="mb-2">
                        {{ pending_state ? $t('평가 참여 요청 승인 확인') : $t('평가 참여 요청 거부 확인') }}
                    </h4>
                    <p class="mb-4">
                        {{ pending_state ? $t('평가 참여 요청 승인 안내') : $t('평가 참여 요청 거부 안내') }}
                    </p>
                    <b-button :variant="pending_state ? 'primary' : 'danger'" @click="handlingAuthRequestRole">
                        {{ pending_state ? $t('승인하기') : $t('거부하기') }}
                    </b-button>
                </div>
                <div v-else-if="is_requesting_access" class="p-4">
                    <div class="text-center">
                        <b-spinner type="grow"
                                   label="권한 요청중입니다."
                                   variant="info"
                                   class="mb-4"
                                   style="width: 4rem; height: 4rem;"
                        />
                        <template v-if="$i18n.locale === 'ko'">
                            <h4 class="gray-600">잠시만 기다려주세요. 요청중입니다.</h4>
                        </template>
                        <template v-if="$i18n.locale === 'ca'">
                            <h4 class="gray-600">请求。 请稍等。</h4>
                        </template>
                        <template v-if="$i18n.locale === 'en'">
                            <h4 class="gray-600">Please wait a moment as it is being processed.</h4>
                        </template>
                        <!-- <h3 class="gray-600 mb-0">요청중입니다.</h3> -->
                    </div>
                </div>
                <div v-else class="p-4">
                    <template v-if="is_request_success">
                        <div class="text-center">
                            <BIconPatchCheckFill class="mb-3" variant="success" style="width: 4rem; height: 4rem;"/>
                            <template v-if="$i18n.locale === 'ko'">
                                <h4 class="mb-1">{{ result_details.user_name }}님을 "{{ result_details.access }}" 상태로
                                    변경하였으며, 이메일({{ result_details.user_email }})로 전송되었습니다.</h4>
                                <h4 class="text-center"> 이 창을 닫아주세요. 감사합니다. </h4>
                                <p class="mt-3 mb-0">{{ $t('잘못 처리했다면 QESG 에 문의해 주세요.') }}</p>
                            </template>
                            <template v-else-if="$i18n.locale === 'en'">
                                <h4 class="mb-1">{{ result_details.user_name }}'s status has been changed to
                                    "{{ $t(result_details.access) }}" and has been sent to email
                                    ({{ result_details.user_email }}).</h4>
                                <h4 class="text-center"> Please, Close this page. Thank you.</h4>
                                <p class="mt-3 mb-0">{{ $t('잘못 처리했다면 QESG 에 문의해 주세요.') }}</p>
                            </template>
                            <template v-else>
                                <h4 class="mb-1">{{
                                        result_details.user_name
                                    }}的状态已更改为"{{
                                        $t(result_details.access)
                                    }}"，并已发送至电子邮件({{ result_details.user_email }})。</h4>
                                <h4>请关闭此页面。 谢谢。</h4>
                                <p class="mt-3 mb-0">{{ $t('잘못 처리했다면 QESG 에 문의해 주세요.') }}</p>
                            </template>

                        </div>
                    </template>
                    <template v-else>
                        <div class="text-center">
                            <!-- 이미 처리된 요청은 실패가 아니다 — 경고색 대신 안내 아이콘 -->
                            <BIconInfoCircleFill v-if="fail_is_info" class="mb-3" variant="info"
                                                 style="width: 4rem; height: 4rem;"/>
                            <BIconExclamationTriangleFill v-else class="mb-3" variant="danger"
                                                          style="width: 4rem; height: 4rem;"/>
                            <h4>{{ $t(fail_message) }}</h4>
                        </div>
                    </template>
                </div>
            </b-col>
        </b-row>
        <!-- <b-row class="align-items-center justify-content-center ">
            <b-col cols="12" lg="auto">
                <div v-if="is_requesting_access === true" class="p-4">
                    <div class="text-center">
                        <b-spinner type="grow"
                            label="권한 요청중입니다."
                            variant="info"
                            class="mb-4"
                            style="width: 4rem; height: 4rem;"
                            />
                        <h4 class="gray-600">잠시만 기다려주세요.</h4>
                        <h3 class="gray-600 mb-0">권한설정 요청중입니다.</h3>
                    </div>
                </div>
                <div v-else class="p-4">
                    <template v-if="is_request_success">
                        <div class="text-center">
                            <BIconPatchCheckFill class="mb-3" variant="success" style="width: 4rem; height: 4rem;" />
                            <h4 class="mb-1">{{ result_details.user_name }}님을 "{{ result_details.access }}" 상태로 변경하였으며, 이메일({{ result_details.user_email }})로 전송되었습니다.</h4>
                            <h4 class="text-center"> 이 창을 닫아주세요. 감사합니다. </h4>
                        </div>
                    </template>
                    <template v-else>
                        <div class="text-center">
                            <BIconExclamationTriangleFill class="mb-3" variant="danger" style="width: 4rem; height: 4rem;" />
                            <h4 class="mb-1">죄송합니다. </h4>
                            <h4>{{ fail_message }}</h4>
                        </div>
                    </template>
                </div>
            </b-col>
        </b-row> -->
    </b-container>
</template>


<script>
import DropdownLanguage from '@shared_components/utils/dropdown-language';
import {BIconPatchCheckFill, BIconExclamationTriangleFill, BIconQuestionCircleFill, BIconInfoCircleFill} from 'bootstrap-vue';

export default {
    name: 'RegistrationAuthorizationRole',
    components: {
        BIconPatchCheckFill,
        BIconExclamationTriangleFill,
        BIconQuestionCircleFill,
        BIconInfoCircleFill,
        DropdownLanguage
    },
    data() {
        return {
            is_requesting_access: null,
            is_request_done: false,
            pending_state: true,
            is_request_success: false,
            result_details: null,
            fail_message: null,
            fail_is_info: false
        };
    },
    computed: {},
    created() {
    },
    mounted() {
        // 링크를 열기만 해도 처리되지 않도록 PUT 은 버튼을 눌렀을 때만 보낸다.
        // 토큰 payload 는 확인 문구 표시용으로만 읽는다(서명 검증은 서버가 PUT 에서 한다).
        try {
            const payload = JSON.parse(decodeURIComponent(escape(atob(
                this.$route.query.token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')
            ))));
            this.pending_state = payload.state !== false;
            if (payload.exp && payload.exp * 1000 < Date.now()) {
                this.fail_message = '이 승인 링크는 유효하지 않거나 만료되었습니다. 담당자(QESG)에게 승인 메일 재발송을 요청해 주세요.';
            }
        } catch (error) {
            this.fail_message = '잘못된 요청입니다. 접근요청에 대한 상세내용과 요청 URL을 QESG에 문의해주세요.';
        }
    },
    destroyed() {
        this.is_requesting_access = null;
        this.is_request_success = true;
        this.result_details = null;
        this.fail_message = null;
    },
    methods: {
        async handlingAuthRequestRole() {
            if (this.is_requesting_access) return;
            try {
                this.is_requesting_access = true;
                const _res_handling_role = await this.$axios.put(`/register/authorization/${this.$route.query.token}`);
                const result_details = _res_handling_role.data;
                result_details.access = result_details.access === 'agree' ? '평가 참여가능' : '평가 참여 거부';
                this.result_details = result_details;
                this.is_request_success = true;
            } catch (error) {
                console.log(error);
                if (error.response) {
                    // 백엔드는 항상 {"message": <코드>} 형태로 응답한다.
                    // 다만 게이트웨이/프록시 오류 등으로 data 가 문자열일 수 있어 양쪽 모두 처리한다.
                    const {data} = error.response;
                    const _code = data && typeof data === 'object' ? data.message : data;
                    let _message = null;
                    if (_code === 'Not_Found_User') {
                        _message = '접근 요청자를 찾을 수 없습니다.';
                    } else if (_code === 'Duplicated_Request') {
                        _message = '이미 처리된 요청입니다.';
                    } else if (_code === 'Invalid_Authorization_Token' || _code === 'Expired_Authorization_Token') {
                        _message = '이 승인 링크는 유효하지 않거나 만료되었습니다. 담당자(QESG)에게 승인 메일 재발송을 요청해 주세요.';
                    } else if (_code === 'Bad Request') {
                        _message = '잘못된 요청입니다. 접근요청에 대한 상세내용과 요청 URL을 QESG에 문의해주세요.';
                    } else {
                        _message = '처리할 수 없는 요청입니다. QESG에 문의해주세요.';
                    }

                    this.fail_message = _message;
                    this.fail_is_info = _code === 'Duplicated_Request';
                } else {
                    this.fail_message = '처리할 수 없는 요청입니다. QESG에 문의해주세요.';
                }
                this.is_request_success = false;
            } finally {
                this.is_request_done = true;
                this.is_requesting_access = false;
            }
        }
    }
};
</script>
